import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { pageview } from "./analytics";

// Core layout
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import NewsletterModal from "./components/NewsletterModal";
import LanguageSelector from "./components/LanguageSelector";

// Homepage components
import Hero from "./components/Hero";
import Features from "./components/Features";
import NewsletterBar from "./components/NewsletterBar";
import VideoShowcase from "./components/VideoShowcase"; // Adjust path if needed
import EasyToUse from "./components/EasyToUse";
import Pricing from "./components/Pricing";
import UseAnywhere from "./components/UseAnywhere";

// Pages
import About from "./pages/About";
import StorePage from "./pages/StorePage";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import PortableClassroom from "./pages/PortableClassroom";
import Careers from "./pages/Careers";
import NewsletterSignupPage from "./pages/NewsletterSignupPage";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

function App() {
  return (
    <Router>
      <ScrollToTop /> 
      <RouteTracker />
      <Navbar />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />

              {/* Book A Demo Button */}
              <div style={{ textAlign: 'center', margin: '20px 0' }}>
                <a 
                  href="https://calendly.com/chipserver/demo" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="book-demo-button"
                >
                  <button style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}>
                    Book a Demo!
                  </button>
                </a>
              </div>

              <EasyToUse />
              <UseAnywhere />
              <Pricing />
              <Features />

              <VideoShowcase />

              {/* More Videos Section */}
              <div style={{ textAlign: 'center', margin: '40px 20px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px', backgroundColor: '#fff' }}>
                <h2 style={{ marginBottom: '20px', fontSize: '24px', fontWeight: 'bold', color: '#343a40' }}>
                  Watch More ChipServer In Action
                </h2>
                <div style={{ margin: '20px 0', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                  <iframe
                    width="896" 
                    height="504" 
                    src="https://www.youtube.com/embed/videoseries?list=PL4juLgynmuxOFl7MG4wdepHIn4e44Ih4I"
                    title="ChipServer YouTube Playlist"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    style={{ borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', maxWidth: '100%' }}
                  ></iframe>
                  <p style={{ marginTop: '15px', color: '#6c757d', fontSize: '14px' }}>
                    Explore our full playlist on <a href="https://www.youtube.com/playlist?list=PL4juLgynmuxOFl7MG4wdepHIn4e44Ih4I" target="_blank" rel="noopener noreferrer">YouTube</a>.
                  </p>
                </div>
              </div>
             
            </>
          }
        />
        
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/portable-classroom" element={<PortableClassroom />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/store/*" element={<StorePage />} /> {/* ✅ Store route added */}
        <Route path="/careers" element={<Careers />} />
        <Route path="/NewsletterSignup" element={<NewsletterSignupPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
      </Routes>

      <NewsletterBar />
      <Footer />
      
      <NewsletterModal />
      <LanguageSelector />
    </Router>
  );
}

// Component to track route changes for analytics
function RouteTracker() {
  const location = useLocation();
  
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);
  
  return null;
}

export default App;
